module.exports = __webpack_public_path__ + "img/SMS.a6956cb3.svg";